import script from "./announcement.vue?vue&type=script&setup=true&lang=js"
export * from "./announcement.vue?vue&type=script&setup=true&lang=js"

import "./announcement.vue?vue&type=style&index=0&id=032a6db1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032a6db1"]])

export default __exports__